import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './Navbar.css';

const PHONE = '919445879508';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen]         = useState(false);
  const { pathname }            = useLocation();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 60);  
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  const links = [
    { to: '/',        label: 'Home'    },
    { to: '/tours',   label: 'Tours'   },
    { to: '/fleet',   label: 'Fleet'   },
    { to: '/map',     label: '🗺️ Map & Reviews' },
    { to: '/gallery', label: 'Gallery' },
    { to: '/about',   label: 'About'   },
    { to: '/contact', label: 'Contact' },
  ];

  return (
    <>
      {/* Mobile top bar */}
      <div className="mobile-topbar">
        <Link to="/" className="mobile-topbar__logo">
          Maggi <span>Cabs</span>
        </Link>
        <a href={`tel:+${PHONE}`} className="mobile-topbar__call">
          <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.73a16 16 0 0 0 6.29 6.29l.92-.92a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
          </svg>
          Call Now
        </a>
      </div>

      {/* Desktop navbar */}
      <header className={`navbar ${scrolled ? 'scrolled' : ''} ${pathname === '/' && !scrolled ? 'transparent' : ''}`}>
        <div className="navbar__inner container">
          <Link to="/" className="navbar__logo">
            <div className="navbar__logo-icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M2 26 L10 12 L16 20 L21 13 L30 26 Z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                <path d="M14 26 L16 22 L18 26" fill="currentColor" opacity="0.5"/>
              </svg>
            </div>
            <div>
              <span className="navbar__logo-name">Maggi Cabs</span>
              <span className="navbar__logo-sub">Kodai Road ↔ Kodaikanal</span>
            </div>
          </Link>

          <nav className={`navbar__nav ${open ? 'open' : ''}`}>
            {links.map(({ to, label }) => (
              <NavLink key={to} to={to} end={to === '/'}
                className={({ isActive }) => `navbar__link ${isActive ? 'active' : ''}`}>
                {label}
              </NavLink>
            ))}
            <a href={`tel:+${PHONE}`} className="navbar__call-btn">
              <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.73a16 16 0 0 0 6.29 6.29l.92-.92a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
              </svg>
              Call Now
            </a>
          </nav>

          <button className={`hamburger ${open ? 'open' : ''}`} onClick={() => setOpen(o => !o)} aria-label="Menu">
            <span/><span/><span/>
          </button>
        </div>
      </header>
    </>
  );
}
